<template>
  <div :class="['cs-image-grid', fullWidth && 'full-grid']" ref="csImageGrid">
    <div v-if="headingTexts || headingTitle" class="cs-grid-item copy">
      <IndexTitle
        v-if="headingTitle"
        type="h4"
        index="02"
        :text="headingTitle"
      />
      <p v-for="(text, index) in headingTexts" :key="index" class="lead">
        {{ text }}
      </p>
    </div>
    <div class="cs-grid-item" v-for="(image, index) in images" :key="index">
      <div>
        <img
          @load="finishedLoaded(index)"
          height="750"
          width="500"
          :src="image"
          v-if="!image.includes('mp4')"
        />
        <video
          v-else
          autoplay
          playsinline
          disablePictureInPicture
          loop
          muted
          preload="metadata"
          disableremoteplayback
          @loadeddata="finishedLoaded(index)"
        >
          <source :src="image" type="video/mp4" v-if="image.includes('mp4')" />
        </video>
      </div>
    </div>
    <div class="cs-grid-item copy" v-if="footerTexts || footerTitle">
      <IndexTitle v-if="footerTitle" type="h4" index="03" :text="footerTitle" />
      <p v-for="(text, index) in footerTexts" :key="index" class="lead">
        {{ text }}
      </p>
    </div>
  </div>
</template>
<script>
import IndexTitle from "@/components/IndexTitle";
import { useTransitionComposable } from "../../composables/transition-composable";
import { ref, watch, onUnmounted, onMounted } from "vue";
import { gsap } from "gsap";

const { transitionState } = useTransitionComposable();
export default {
  name: "CsImageGrid",
  components: {
    IndexTitle,
  },
  props: {
    fullWidth: {
      type: Boolean,
      default: false,
    },
    headingTitle: {
      type: String,
    },
    headingTexts: {
      type: Array,
    },
    footerTitle: {
      type: String,
    },
    footerTexts: {
      type: Array,
    },
    images: {
      type: Array,
    },
  },
  setup() {
    const csImageGrid = ref(null);
    const grid = ref(null);
    const ctx = ref();
    let mounted = false;
    watch(
      [() => transitionState.transitionComplete, csImageGrid],
      (newValue) => {
        if (newValue[0] == true && csImageGrid.value) {
          if (!mounted) {
            const el = csImageGrid.value;
            ctx.value = gsap.context(() => {
              let mm = gsap.matchMedia();
              mm.add(`(min-width: 768px)`, () => {
                ctx.value = gsap.timeline({
                  scrollTrigger: {
                    trigger: el,
                    start: "0% 40%", // when the top of the trigger hits the top of the viewport
                    end: "100%",
                  },
                });

                ctx.value.fromTo(
                  el.querySelectorAll(".cs-grid-item:not(.copy)"),
                  {
                    opacity: 0,
                    duration: 4,
                    ease: "power1.inOut",
                    y: 60,
                  },
                  {
                    opacity: 1,
                    stagger: {
                      from: el.classList.contains("full-grid")
                        ? "start"
                        : "random",
                      amount: 1,
                      axis: "x",
                    },
                    y: 0,
                  },
                );
              });
            });
            mounted = true;
          }
        }
      },
      {
        immediate: true,
      },
    );

    onUnmounted(() => {
      ctx.value.revert(); // <- Easy Cleanup!
    });
    return { csImageGrid, grid }; // WILL NOT WORK WITHOUT THIS
  },
  methods: {
    finishedLoaded(val) {
      if (val === this.images.length - 1) {
        this.$emit("loaded", true);
      }
    },
  },
};
</script>
